import script from "./NoReturned.vue?vue&type=script&setup=true&lang=js"
export * from "./NoReturned.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__